export class TextTool {
  static validateUUID(text) {
    const uuidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(text);
  }

  static formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes";

    const k = 1024;
    const units = ["Bytes", "KB", "MB", "GB", "TB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    const noDecimals = i < 2; // index 0 = Bytes, 1 = KB
    const dm = noDecimals ? 0 : decimals;

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + units[i];
  }
}
